// Helper function to get display price based on selected portion
const applyPriceAdjustment = (
	basePrice,
	restaurant,
	orderType = "table",
	specificAdjustment = null
) => {
	const base =
		typeof basePrice === "number" ? basePrice : parseFloat(basePrice);
	if (!isFinite(base)) return 0;
	if (!restaurant) return base;

	let type = "percent";
	let rawValue = 0;

	if (specificAdjustment) {
		// Use specific adjustment if provided (e.g. from Seat Category)
		type = specificAdjustment.type;
		rawValue = specificAdjustment.value;
	} else if (orderType === "online") {
		type = restaurant.onlinePricingAdjustmentType;
		rawValue = restaurant.onlinePricingAdjustmentValue;
	} else {
		type = restaurant.tablePricingAdjustmentType;
		rawValue = restaurant.tablePricingAdjustmentValue;
	}

	const value =
		typeof rawValue === "number" ? rawValue : parseFloat(rawValue);
	const adj = isFinite(value) ? value : 0;
	if (type === "fixed") return base + adj;
	return base + base * (adj / 100);
};

const getDisplayPrice = (
	item,
	selectedPortions,
	restaurant,
	orderType = "table",
	specificAdjustment = null
) => {
	let base = 0;

	if (!item.isPortionWise) {
		base = item.price;
	} else if (!item.portions || item.portions.length === 0) {
		base = item.price;
	} else {
		const selectedPortion =
			selectedPortions[item.id] || item.portions[0].name;
		const portion = item.portions.find((p) => p.name === selectedPortion);
		base = portion ? portion.price : item.portions[0].price;
	}

	return applyPriceAdjustment(
		base,
		restaurant,
		orderType,
		specificAdjustment
	);
};

export { applyPriceAdjustment, getDisplayPrice };
